<template>
  <RevDialog :name :title="i18n(translations.title)">
    <template #body>
      <p class="body-1">{{ i18n(translations.subtitle) }}</p>

      <div class="mt-8 flex items-center gap-4">
        <IconClock size="16" />
        <p class="body-2-bold">
          {{ i18n(translations.text) }}
        </p>
      </div>
    </template>

    <template #footer="{ close }">
      <RevButton
        full-width="always"
        :to="
          resolveLocalizedRoute({
            name: CUSTOMER_CARE.DIAGNOSIS.SELF,
            params: { orderlineId: params.uuid },
          })
        "
        :tracking="{
          name: 'go_help_center',
          zone: `reviews_page_${formStep + 1}`,
          pageType: 'review_form',
        }"
        variant="primary"
        @click="close"
      >
        {{ i18n(translations.buttonTitle) }}
      </RevButton>
    </template>
  </RevDialog>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { IconClock } from '@ds/icons/IconClock'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'

import { useFormStep } from '../../composables/useFormStep'

import translations from './Care.translations'

defineProps<{ name: string }>()
const { formStep } = useFormStep()

const { params } = useRoute()

const resolveLocalizedRoute = useRouteLocationWithLocale()

const i18n = useI18n()
</script>
